module.exports = __webpack_public_path__ + "img/icon3.20b9959d.png";